module.exports = __webpack_public_path__ + "static/media/news2.77f6b6ee.jpg";